'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
function $ct_Lio_intela_sites_digitalinternship_Page$SegmentKey__T__T__($thiz, key, path) {
  $thiz.d2 = key;
  $thiz.dJ = path;
  return $thiz;
}
export { $ct_Lio_intela_sites_digitalinternship_Page$SegmentKey__T__T__ as $ct_Lio_intela_sites_digitalinternship_Page$SegmentKey__T__T__ };
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page$SegmentKey() {
  this.d2 = null;
  this.dJ = null;
}
export { $c_Lio_intela_sites_digitalinternship_Page$SegmentKey as $c_Lio_intela_sites_digitalinternship_Page$SegmentKey };
$p = $c_Lio_intela_sites_digitalinternship_Page$SegmentKey.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page$SegmentKey;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page$SegmentKey() {
}
export { $h_Lio_intela_sites_digitalinternship_Page$SegmentKey as $h_Lio_intela_sites_digitalinternship_Page$SegmentKey };
$h_Lio_intela_sites_digitalinternship_Page$SegmentKey.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
var $d_Lio_intela_sites_digitalinternship_Page$SegmentKey = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i(0, "io.intela.sites.digitalinternship.Page$SegmentKey", ({
  a9: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page$SegmentKey as $d_Lio_intela_sites_digitalinternship_Page$SegmentKey };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page$-Segment-Key.js.map
